<script>
import { computed, defineComponent, watch } from '@vue/composition-api';

export default defineComponent({
  props: {
    stores: {
      type: Array,
      default: () => [],
    },
    changeStoreSelected: {
      type: Function,
      default: () => () => {},
    },
    storeSelected: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  setup(props, { root }) {
    const stores = computed(() => props.stores);
    const loading = computed(() => props.loading);
    const { changeStoreSelected } = props;

    const sellerStores = computed(() => {
      if (!loading.value) {
        const allStores = {
          default: true,
          name: 'Todas as Lojas',
          id: [...stores.value.map((el) => el.id)],
        };
        const mappedStores = stores.value.map((el) => {
          const store = {
            ...el,
            id: [el.id],
          };
          if (el.alternateIds) store.id.push(...el.alternateIds);
          return store;
        });
        if (mappedStores.length === 1) return [...mappedStores];
        return [allStores, ...mappedStores];
      }
      return [];
    });

    watch(
      sellerStores,
      () => {
        if (sellerStores.value) {
          if (sellerStores.value.length === 1) {
            // eslint-disable-next-line prefer-destructuring
            changeStoreSelected(root.$store.state.store);
          }
        }
      },
      { immediate: true },
    );

    return {
      sellerStores,
    };
  },

  data() {
    return {
      selected: [],
    };
  },

  computed: {
    seeAllSelected() {
      return this.selected.name === 'Todas as Lojas';
    },
  },

  mounted() {
    this.$set(this, 'selected', this.$store.getters.getStore);
  },

  methods: {
    showAllStores() {
      if (!this.loading) {
        const allStores = {
          name: 'Todas as Lojas',
          id: this.stores.map((el) => el.id),
        };
        this.selected = allStores;
        this.changeStoreSelected(allStores);
      }
    },
    selectStore() {
      if (!this.loading) {
        this.selected = this.$store.state.store;
        this.changeStoreSelected(this.$store.state.store);
      }
    },
  },
});
</script>
<template>
  <div class="stores">
    <div class="stores__label">
      Você está visualizando
    </div>
    <div class="stores-btn">
      <span>
        <v-btn
          flat
          small
          class="stores-btn__label"
          :class="{'apply-green': !seeAllSelected}"
          @click="selectStore()"
        >
          {{ $store.state.customer.name }} -
          {{ $store.state.store.name }}
        </v-btn>
      </span>
      <span
        v-if="sellerStores.length > 1"
      >
        <v-icon
          color="primary"
          small
        >
          $vuetify.icons.circle
        </v-icon>
      </span>
      <span
        v-if="sellerStores.length > 1"
      >
        <v-btn
          flat
          small
          class="stores-btn__label"
          :class="{'apply-green': seeAllSelected}"
          @click="showAllStores()"
        >
          ver todas
        </v-btn>
      </span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
::v-deep .v-input input {
    max-height: 40px !important;
}
.stores__label {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
}
::v-deep .v-input {
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
}
.stores {
  margin-top: 20pt;
  margin-bottom: 20pt;
    &__label {
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 400;
      font-size: 11px;
      line-height: 102%;
      color: rgba(0, 0, 0, 0.54);
      margin-bottom: 5px;
    }
    & .v-input input {
      max-height: 40px !important;
    }
  .stores-btn {
    display: flex;
    align-items: center;
    &__txt {
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      text-decoration-line: underline;
      color: #3D6961;
      text-transform: none;
      padding: 0px;
      margin: 0px;
    }
    &__label {
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 400;
      color: #140C22;
      padding-bottom: 5xp;
      margin: 0px;
      min-width: 0px;
      text-transform: none;
    }
  }
  .apply-green {
      font-family: 'Nunito Sans';
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      text-decoration-line: underline;
      color: #3D6961;
  }
  }
</style>
